import ProductSlider from "../../../Components/Sliders/ProductSlider/ProductSlider";
import { useRecommendedProducts } from "../../../Hooks/useProductsBySubCategory";

export const RecommendedProducts = () => {
  const { products, loading } = useRecommendedProducts();

  return (
    <ProductSlider title="Recommended Products" link="/" products={products} loading={loading} />
  );
};
